import { useRef, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const navRef = useRef();
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const lastScrollY = useRef(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY.current && currentScrollY > 10) {
        setIsHidden(true);
      } else {
        setIsHidden(false);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openDropdown &&
        !event.target.closest(".custom-dropdown")
      ) {
        setOpenDropdown(null);
      }
    };
  
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [openDropdown]);

  useEffect(() => {
    const closeOnScroll = () => {
      if (openDropdown) {
        setOpenDropdown(null);
      }
    };
  
    window.addEventListener("scroll", closeOnScroll, { passive: true });
    return () => window.removeEventListener("scroll", closeOnScroll);
  }, [openDropdown]);

  const showNavbar = () => setIsNavOpen(!isNavOpen);
  const closeNavbar = () => setIsNavOpen(false);
  const toggleDropdown = (name) =>
    setOpenDropdown(openDropdown === name ? null : name);

  const getLogoSrc = () => {
    return windowWidth <= 1118
      ? "/images/navbar/logo-mobile.png"
      : "/images/navbar/logo.png";
  };

  return (
    <div className={`header ${isHidden ? "hidden" : ""}`}>
      <a href="/" className="brand-logo">
        <img src={getLogoSrc()} alt="Logo" className="logo-img" />
      </a>

      <div className={`nav ${isNavOpen ? "responsive_nav" : ""}`} ref={navRef}>
        {location.pathname !== "/" && (
          <a href="/" onClick={closeNavbar}>
            Início 
          </a>
        )}

        <a href="/tecnologias" onClick={closeNavbar}>
          Tecnologias
        </a>
        <a href="/consultorio" onClick={closeNavbar}>
          Consultório
        </a>

        <div className="custom-dropdown">
          <button
            className="dropdown-button"
            onClick={() => toggleDropdown("cirurgias")}
            aria-expanded={openDropdown === "cirurgias"}
          >
            Cirurgias
            <span
              className={`dropdown-arrow ${
                openDropdown === "cirurgias" ? "open" : ""
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </span>
          </button>

          {openDropdown === "cirurgias" && (
            <div className="dropdown-menu-cirurgia">
              <a href="/corpo" onClick={closeNavbar}>
                Corpo
              </a>
              <a href="/face" onClick={closeNavbar}>
                Face
              </a>
              <a href="/mamas" onClick={closeNavbar}>
                Mamas
              </a>
              <a href="/intimas" onClick={closeNavbar}>
                Íntimas
              </a>
              <a href="/reparadoras" onClick={closeNavbar}>
                Reparadoras
              </a>
            </div>
          )}
        </div>

        <a href="/sobre" onClick={closeNavbar}>
          Sobre
        </a>
        <a href="/contato" onClick={closeNavbar}>
          Contato
        </a>

        <a
          href="https://api.whatsapp.com/send/?phone=5561986253859&type=phone_number&app_absent=0"
          target="_blank"
          rel="noopener noreferrer"
          className="agendamento-btn"
          onClick={closeNavbar}
        >
          Agendamentos
        </a>

        <button className="nav-btn nav-close-btn" onClick={showNavbar}>
          <i className="material-icons">close</i>
        </button>
      </div>

      {!isNavOpen && (
        <button className="nav-btn" onClick={showNavbar}>
          <i className="material-icons">menu</i>
        </button>
      )}
    </div>
  );
}

export default Navbar;
